import { To } from 'react-router-dom';

/**
 * Merge the current URL's search params into a navigation target so query
 * params (e.g. ?systemSource=GDS_NEO) are preserved across navigation.
 * Existing params on `to` take precedence over the current ones.
 */
export const preserveQuery = (to: To, search: string): To => {
  if (typeof to === 'string') {
    // If `to` already has search params, merge them
    if (to.includes('?')) {
      const [path, existingSearch] = to.split('?');
      const currentParams = new URLSearchParams(search);
      const newParams = new URLSearchParams(existingSearch);

      // Merge params (params on `to` override the current ones)
      currentParams.forEach((value, key) => {
        if (!newParams.has(key)) {
          newParams.set(key, value);
        }
      });

      const searchString = newParams.toString();
      return searchString ? `${path}?${searchString}` : path;
    }

    // Simple case: just append the current search params
    return `${to}${search}`;
  }

  // For object-style `to`, preserve the current search when none is set
  return {
    ...to,
    search: to.search || search
  };
};
